import React from 'react';
import './SummaryCards.css';

const SummaryCards = ({ summary, isLoading }) => {
  const cards = [
    {
      label: "Total visitors",
      key: "totalUsers",
      iconBg: "ga-icon-purple",
      iconColor: "#7c3aed",
      icon: (
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      )
    },
    {
      label: "Sessions",
      key: "totalSessions",
      iconBg: "ga-icon-teal",
      iconColor: "#0d9488",
      icon: (
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      )
    },
    {
      label: "Page views",
      key: "totalPageViews",
      iconBg: "ga-icon-blue",
      iconColor: "#2563eb",
      icon: (
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      )
    },
    {
      label: "New visitors",
      key: "newUsers",
      iconBg: "ga-icon-green",
      iconColor: "#059669",
      icon: (
        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
        </svg>
      )
    }
  ];

  if (isLoading) {
    return (
      <div className="ga-summary-grid">
        {cards.map((card, index) => (
          <div key={index} className="ga-summary-skeleton-card">
            <div className="ga-summary-card-header">
              <div className="ga-skeleton" style={{ width: '40px', height: '40px', borderRadius: '10px' }}></div>
            </div>
            <div className="ga-skeleton" style={{ width: '80px', height: '28px', marginTop: '12px' }}></div>
            <div className="ga-skeleton" style={{ width: '60px', height: '14px', marginTop: '8px' }}></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="ga-summary-grid">
      {cards.map((card) => (
        <div key={card.key} className="ga-summary-card">
          <div className="ga-summary-card-header">
            <div className={`ga-summary-icon ${card.iconBg}`} style={{ color: card.iconColor }}>
              {card.icon}
            </div>
          </div>
          <div className="ga-summary-value">
            {(summary?.[card.key] || 0).toLocaleString("en-IN")}
          </div>
          <div className="ga-summary-label">{card.label}</div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;